<script setup lang="ts">
import {
  getQuestionStatusName,
  statuses,
  type SelectBoxQuestion,
} from '../calendarQuestion'
import DolphinTextInput from '@/components/atoms/DolphinTextInput.vue'
import DolphinRadioButtonInContainer from '@/components/molecules/DolphinRadioButtonInContainer.vue'
import FlatButton from '@/components/atoms/FlatButton.vue'
import ButtonCircleClose from '@/components/atoms/ButtonCircleClose.vue'
import { computed } from 'vue'

const statusOptions = computed(() => {
  return statuses.map(status => ({
    value: status,
    label: getQuestionStatusName(status),
  }))
})

const model = defineModel<SelectBoxQuestion>()

const addOption = () => {
  if (model.value?.options) {
    model.value.options = [...model.value.options, '']
  }
}

const removeOption = (index: number) => {
  if (model.value?.options) {
    model.value.options = model.value.options.filter((_, i) => i !== index)
  }
}
</script>

<template>
  <div v-if="model" :class="$style.navigation">
    <div :class="$style.questionTextSection">
      <label>質問内容</label>
      <DolphinTextInput
        v-model="model.questionText"
        type="text"
        :class="$style.input"
      />
    </div>

    <div :class="$style.statusSection">
      <label>任意・必須</label>
      <div :class="$style.statusRadioGroup">
        <DolphinRadioButtonInContainer
          v-for="option in statusOptions"
          :key="option.value"
          :class="$style.statusRadioGroup__option"
          name="status"
          v-model="model.status"
          :value="option.value"
        >
          {{ option.label }}
        </DolphinRadioButtonInContainer>
      </div>
    </div>

    <div :class="$style.optionsSection">
      <label>選択肢</label>
      <ul :class="$style.optionsList">
        <li
          v-for="(_, index) in model.options"
          :key="index"
          :class="$style.optionsList__item"
        >
          <DolphinTextInput
            v-model="model.options[index]"
            type="text"
            :class="$style.optionsList__input"
          />
          <ButtonCircleClose @click="removeOption(index)" />
        </li>
      </ul>
      <FlatButton @click="addOption">選択肢を追加</FlatButton>
    </div>
  </div>
</template>

<style lang="scss" module>
.navigation {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.input {
  font-size: 16px;
}

.questionTextSection {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.statusSection {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.statusRadioGroup {
  display: flex;
  gap: 8px;

  &__option {
    flex: 1;
  }
}

.optionsSection {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.optionsList {
  display: flex;
  flex-direction: column;
  gap: 8px;

  &__item {
    display: flex;
    gap: 8px;
  }

  &__input {
    flex: 1;
    min-width: 0;
  }
}
</style>
